import { ReactNode, useState } from 'react';
import { ChevronDown } from 'lucide-react';

interface Props {
  title: ReactNode;
  defaultOpen?: boolean;
  className?: string;
  children: ReactNode;
}

/** Card whose body folds away behind its title; collapsed by default. */
export default function CollapsibleCard({ title, defaultOpen = false, className = '', children }: Props) {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <div className={`card p-0 ${className}`}>
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        aria-expanded={open}
        className="flex w-full items-center justify-between gap-3 px-5 py-4 text-left"
      >
        <span className="font-display text-lg font-semibold">{title}</span>
        <ChevronDown
          size={18}
          className={`shrink-0 text-ink-muted transition-transform ${open ? 'rotate-180' : ''}`}
        />
      </button>
      {open && <div className="px-5 pb-5">{children}</div>}
    </div>
  );
}
